const glob = require("glob");
import Swal from "sweetalert2";
const swalWithCustomClass = Swal.mixin({
  customClass: {
    container: "custom-confirm",
    confirmButton: "button button-confirm",
    cancelButton: "button button-cancel"
  },
  allowOutsideClick: false,
  buttonsStyling: false
});
const exec = require("child_process").execFile;
const path = require("path");
const { app } = require("electron").remote;

const checkDriver = () => {
  return new Promise((resolve, reject) => {
    if (process.platform === "darwin") {
      const find = glob.sync("/Library/Extensions/usbserial.kext").length > 0;

      console.log(find);

      resolve(true); // MAc 不檢查 DRIVER
    } else if (process.platform === "win32") {
      const ret = glob.sync("C:\\Windows\\System32\\DriverStore\\FileRepository\\ch341ser.inf*").length > 0;
      console.log(ret);
      resolve(ret);
    }
  });
};

const installDriver = () => {
  return new Promise((resolve, reject) => {
    swalWithCustomClass
      .fire({
        title: "Notice",
        text: "Please click OK to install USB driver.",
        confirmButtonText: "OK",
        showCancelButton: false,
        showCloseButton: true
      })
      .then((result) => {
        console.log('here?', result);
        let driverPath = "";
        console.log(app.getAppPath());
        if (process.platform === "darwin") {
          driverPath = path.join(app.getAppPath(), "../driver/CH34x_Install_V1.4.pkg");
          exec("open", [driverPath], () => {});
        } else if (process.platform === "win32") {
          const isDevelopment = app.getAppPath().indexOf("app.asar") === -1;
          driverPath = path.join(
            app.getAppPath(),
            isDevelopment
              ? "../driver/CH341SER.EXE"
              : "../../driver/CH341SER.EXE"
          );
          console.log(driverPath);
          exec(driverPath, () => {});
        }
        if (checkDriver()) {
          resolve("Installed  driver");
        } else {
          reject("Not installed");
        }
      });
  });
};

export const checkDreiverHandler = () => {
  checkDriver().then(installed => {
    console.log(installed);
    if (!installed) {
      installDriver();
    }
  });
};
